import React from 'react';
import { connect } from 'react-redux';

import Candle from './components/Candle';
import getHeight, { FULL_CANDLE_HEIGHT, SNUFFED_CANDLE_HEIGHT } from './utils/getHeight';

function getContainerTop(actions, isExceptional) {
  // If we have more than 20 actions, we have a full candle
  if (actions > 20) {
    return -FULL_CANDLE_HEIGHT;
  }

  // If we have 0 actions, we're showing a snuffed candle
  if (actions <= 0) {
    return -SNUFFED_CANDLE_HEIGHT;
  }

  // If we are Exceptional, then we are showing either the height of
  // the remaining candle, or the height of the snuffed candle, whichever
  // is taller
  if (isExceptional) {
    return -Math.max(
      getHeight({ actions }),
      SNUFFED_CANDLE_HEIGHT,
    );
  }
  return -getHeight({ actions });
}

function ActionCandles({ actions, actionBankSize }) {
  if (actionBankSize === undefined) {
    return null;
  }

  // Exceptional Friends have 40 actions, which are rendered as two candles
  const isExceptional = actionBankSize === 40;

  // We want to pin the candles to the top of the sidebar, overlapping the
  // area header, so we need to set the 'top' dynamically to the height of
  // the tallest candle
  const containerTop = getContainerTop(actions, isExceptional);

  if (isExceptional) {
    return (
      <div
        className="candle-container"
        style={{ top: containerTop }}
      >
        <Candle actions={Math.min(actions, 20)} />
        <Candle actions={Math.max(actions - 20, 0)} right />
      </div>
    );
  }

  return (
    <div
      className="candle-container"
      style={{ top: containerTop }}
    >
      <Candle actions={actions} />
    </div>
  );
}

ActionCandles.displayName = 'ActionCandles';

const mapState = ({ actions: { actions, actionBankSize } }) => ({ actions, actionBankSize });

export default connect(mapState)(ActionCandles);